class ProductReview extends HTMLElement {
    constructor() {
        super();

        this.reviewContainer = document.getElementById('product-review');
        this.averageScoreElement = document.getElementById('review-average-score');
        this.reviewsHeader = document.getElementById('header-tab-reviews');
        this.questionsHeader = document.getElementById('header-tab-questions');
        this.goToReviewLink = document.getElementById('testfreaks-badge');
        this.writeReviewLink = document.getElementById('write-review-link');
        this.tfTabWrite = document.getElementById('tf-tab-write');
        this.askLink = document.getElementById('qa-review-link');
        this.tfTabAsk = document.getElementById('tf-tab-ask');
        this.tabHeaders = document.querySelectorAll('.tabs-testfreaks-header .tab-header');
        this.tabContents = document.querySelectorAll('.tabs-testfreaks-content .tab-content');

        this.fetchAndRenderReviews();
        this.renderTabs(this.tabHeaders, this.tabContents);
    }

    async fetchAndRenderReviews() {
        const productId = this.getAttribute('product-id');
        const productUrl = this.getAttribute('product-url');

        const data = await this.fetchReviewData(productId);

        if (data) {
            this.renderContents(data, productUrl);
            this.reviewContainer.style.display = 'block';
            this.renderHeader(data);
        }
    }

    async fetchReviewData(productId) {
        const url = `https://js.testfreaks.com/onpage/georges.com.au/reviews.json?key=${productId}`;

        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return await response.json();
        } catch (error) {
            console.error('There was a problem with the fetch operation:', error);
        }
    }

    renderTabs(tabHeaders, tabContents) {
        if (tabHeaders.length > 0 && tabContents.length > 0) {
            tabHeaders[0].classList.add('active-tab');
            tabContents[0].classList.add('active-tab');
        }

        tabHeaders.forEach(header => {
            header.addEventListener('click', () => {
                this.switchTab(header, tabHeaders, tabContents);
            });
        });

        // Initialize the Reviews tab logic on first load
        this.initializeReviewLogic();

        // Set up the write review link to open the relevant tab and trigger the write review action
        if (this.writeReviewLink) {
            this.writeReviewLink.addEventListener('click', (event) => {
                event.preventDefault();
                this.switchToTab('testfreaks-reviews');
                this.initializeReviewLogic(() => {
                    this.tfTabWrite.click();
                });
            });
        }
        
        if (this.goToReviewLink) {
            this.goToReviewLink.addEventListener('click', (event) => {
                event.preventDefault();
                const reviewTabHeader = document.querySelector('[data-sticky-menu-tab-item="reviews"]');
                if (reviewTabHeader && !reviewTabHeader.classList.contains('active')) {
                    reviewTabHeader.click();
                    setTimeout(function(){
                        window.scrollTo({
                            top: reviewTabHeader.closest('.tabs-section').getBoundingClientRect().top,
                            behavior: "smooth"
                        });
                    }, 200);
                }
            });
        }

        // Set up the ask question link to open the relevant tab and trigger the ask question action
        if (this.askLink) {
            this.askLink.addEventListener('click', (event) => {
                event.preventDefault();
                this.switchToTab('testfreaks-qa');
                this.initializeQaLogic(() => {
                    this.tfTabAsk.click();
                });
            });
        }
    }

    switchTab(header, tabHeaders, tabContents) {
        // Remove 'active' class from all headers and contents
        tabHeaders.forEach(h => h.classList.remove('active-tab'));
        tabContents.forEach(content => content.classList.remove('active-tab'));

        // Add 'active' class to the clicked tab and corresponding content
        header.classList.add('active-tab');
        const targetContent = document.getElementById(header.getAttribute('data-target'));
        if (targetContent) {
            targetContent.classList.add('active-tab');
        }

        // Initialize the logic depending on which tab is clicked
        if (header.getAttribute('data-target') === 'testfreaks-qa') {
            this.initializeQaLogic();
        } else if (header.getAttribute('data-target') === 'testfreaks-reviews') {
            this.initializeReviewLogic();
        }
    }

    switchToTab(targetTabId) {
        const header = Array.from(this.tabHeaders).find(header => header.getAttribute('data-target') === targetTabId);
        if (header) {
            this.switchTab(header, this.tabHeaders, this.tabContents);
        }
    }

    initializeReviewLogic(callback) {
        this.waitForElement('#testfreaks-reviews', () => {
            this.waitForElement('#tf-tab-write', () => {
                this.tfTabWrite = document.getElementById('tf-tab-write');
                if (callback) callback();
            });
        });
    }

    initializeQaLogic(callback) {
        this.waitForElement('#testfreaks-qa', () => {
            this.waitForElement('#tf-tab-ask', () => {
                this.tfTabAsk = document.getElementById('tf-tab-ask');
                if (callback) callback();
            });
        });
    }

    renderHeader(data) {
    // Use default values (0) if review or question counts are undefined or NaN
    const userReviewCount = data.user_review_count || 0;
    const proReviewCount = data.pro_review_count || 0;
    const yourReviewCount = data.your_review_count !== undefined && data.your_review_count !== null
        ? data.your_review_count
        : 0;
    const questionCount = data.your_question_count !== undefined && data.your_question_count !== null
        ? data.your_question_count
        : 0;

    // Calculate total review count
    // If your_review_count doesn't exist, just use pro + user counts (they're separate review types)
    const reviewCount = yourReviewCount > 0
        ? userReviewCount + proReviewCount + yourReviewCount
        : userReviewCount + proReviewCount;

        const reviewsHtml = `
          <div class="testfreaks-reviews">
            <div class="reviews-title-count">Reviews (${reviewCount})</div>
          </div>`;

        const questionsHtml = `
          <div class="testfreaks-questions">
            <div class="questions-title-count">Questions & Answers (${questionCount})</div>
          </div>`;

        if (this.reviewsHeader) {
            this.reviewsHeader.innerHTML = reviewsHtml;
        }
        if (this.questionsHeader) {
            this.questionsHeader.innerHTML = questionsHtml;
        }
    }

    renderContents(data, productUrl) {
        // Calculate average score with fallback
        // your_avg_score is 1-5 scale, score is 1-10 scale
        // If your_avg_score doesn't exist, convert score from 10-point to 5-point scale
        let avgScore = null;
        if (data.your_avg_score !== undefined && data.your_avg_score !== null) {
            avgScore = data.your_avg_score;
        } else if (data.score !== undefined && data.score !== null) {
            // Convert from 10-point scale to 5-point scale
            avgScore = data.score / 2;
        }

        // Calculate review count with fallback
        const userReviewCount = data.user_review_count || 0;
        const proReviewCount = data.pro_review_count || 0;
        const yourReviewCount = data.your_review_count !== undefined && data.your_review_count !== null
            ? data.your_review_count
            : 0;
        
        // For ratingCount in JSON-LD, use your_review_count if available, otherwise use total of pro + user
        const ratingCount = yourReviewCount > 0
            ? yourReviewCount
            : (userReviewCount + proReviewCount);

        if (avgScore !== null) {
            const scoreHtml = `
                <div class="testfreaks-badge testfreaks-badge-custom">
                  <div class="testfreaks">
                    <div class="tf-row">
                      <div class="tf-score">
                        <div class="tf-stars tf-stars-svg">
                          <div class="tf-stars-svg tf-stars-fg" style="width: ${avgScore * 20}%;"></div>
                        </div>
                      </div>
                      <div class="tf-rating">${avgScore.toFixed(1)}</div>
                    </div>
                    <script type="application/ld+json">
                      {
                        "@id": "${productUrl}/#/schema/Product",
                        "@context": "https://schema.org",
                        "aggregateRating": {
                          "@type": "AggregateRating",
                          "ratingValue": "${avgScore.toFixed(1)}",
                          "ratingCount": ${ratingCount}
                        }
                      }
                    </script>
                  </div>
                </div>`;

            if (this.averageScoreElement) {
                this.averageScoreElement.innerHTML = scoreHtml;
            }
        } else {
            // Handle the case where there are no reviews
            const noReviewsHtml = `
                <div class="testfreaks-badge testfreaks-badge-custom">
                  <div class="testfreaks">
                    <div class="tf-row">
                      <div class="tf-no-reviews">
                        No reviews yet.
                      </div>
                    </div>
                  </div>
                </div>`;

            if (this.averageScoreElement) {
                this.averageScoreElement.innerHTML = noReviewsHtml;
            }
        }
    }

    waitForElement(selector, callback) {
        const element = document.querySelector(selector);
        if (element) {
            callback();
        } else {
            const observer = new MutationObserver(() => {
                if (document.querySelector(selector)) {
                    callback();
                    observer.disconnect();
                }
            });

            observer.observe(document.body, { childList: true, subtree: true });
        }
    }
}

customElements.define('product-review', ProductReview);
